import { URL_PARAMETERS } from "../../../common/utils/const.util";
import {
  getUrlParameterValue,
  setUrlParameter,
} from "../../../common/utils/url.util";

export class ParentService {
  public static addEventListeners() {
    $(".user-type li").on("click", (event) => {
      if (event.currentTarget.innerHTML.includes("<a")) {
        return;
      }
      const isRegistered = event.currentTarget.className === "registered";

      setUrlParameter(URL_PARAMETERS.USER, isRegistered.toString());
      setUrlParameter(URL_PARAMETERS.STEP, "1");
      this.nextStepEvents();
    });
  }

  public static nextStepEvents() {
    $(".box.show").removeClass("show");
    $(".box.child").addClass("show");

    const isRegistered = getUrlParameterValue(URL_PARAMETERS.USER) === "false";
    if (isRegistered) {
      $(".box.child .form-box").addClass("show");
    }
  }
}
